var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModulesHeaderImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3479.65 3462.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3736.27,
    y1: 3413.97,
    x2: 1231.23,
    y2: 1222.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1871.96,
    y1: 2411,
    x2: 1779.27,
    y2: 3910.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1886.71,
    y1: -582.15,
    x2: 1667.62,
    y2: 2687.25,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1913.59,
    y1: 2309.33,
    x2: 1837.76,
    y2: 3017.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 454.48,
    y1: -901.03,
    x2: 462.91,
    y2: 904.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 689.99,
    y1: 142.15,
    x2: 552.9,
    y2: 1744.45,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 3003.34,
    y1: 343.4,
    x2: 2866.25,
    y2: 1945.7,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 2174.79,
    y1: 271.33,
    x2: 2037.69,
    y2: 1873.63,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 2014.91,
    y1: 921.69,
    x2: 2031.81,
    y2: 2282.06,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 525.09,
    y1: 940.25,
    x2: 541.98,
    y2: 2300.61,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1270.32,
    y1: -904.85,
    x2: 1278.76,
    y2: 900.26,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 2120.41,
    y1: -908.83,
    x2: 2128.84,
    y2: 896.28,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 2948.89,
    y1: -912.71,
    x2: 2957.32,
    y2: 892.41,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 2139.68,
    y1: -1059.5,
    x2: 1794.48,
    y2: 631.98,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1581.43,
    y1: 318.32,
    x2: 2087.53,
    y2: 318.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcd209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7b733"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1612.74,
    y1: 605.3,
    x2: 2055.61,
    y2: 605.3,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 3011.07,
    y1: 2405.78,
    x2: 3002.65,
    y2: 2064.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 3037.48,
    y1: 3180.91,
    x2: 3263.64,
    y2: 3180.91,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 3348.34,
    y1: 2675.15,
    x2: 3236.34,
    y2: 3403.16,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 3111.36,
    y1: 2638.69,
    x2: 2999.36,
    y2: 3366.7,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 2900.25,
    y1: 3197.73,
    x2: 3031.21,
    y2: 3197.73,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 2618.13,
    y1: 2215.15,
    x2: 2874.51,
    y2: 2215.15,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 3567.68,
    y1: 1511.79,
    x2: 3019.97,
    y2: 2379.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 3538.66,
    y1: 2315.26,
    x2: 2923.54,
    y2: 2867.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 2939.95,
    y1: 2341.03,
    x2: 3020.09,
    y2: 2341.03,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 2954.41,
    y1: 2261.14,
    x2: 3333.59,
    y2: 2058.91,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 2910.46,
    y1: 2678.59,
    x2: 2573.41,
    y2: 3302.14,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 581.96,
    y1: 2990.97,
    x2: 1436.23,
    y2: 2990.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b09b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#96c93d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 943.42,
    y1: 2783.23,
    x2: 1796.36,
    y2: 2783.23,
    xlinkHref: "#linear-gradient-28"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M3310.54,2275.61c-323.75,762.3-1186.15,1189.35-1934.03,1074.16-121.69-18.75-455.32-74.58-750.7-338C57.18,2504.67-64.42,1500.54,394.27,792.91,728.12,277.87,1326.58-14.08,1895.24,.52c122.49,3.15,591.91,22.53,1004.46,362.71,60.59,49.97,194.24,168.7,314.69,357.05,282.84,442.3,307.15,1058.52,96.15,1555.33Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "1474.1 2521.71 1401.08 3176.58 2248.22 3176.58 2137.88 2521.71 1474.1 2521.71",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,861.47v1543.32c0,126.96,101.17,230.78,228.09,234.05,563.69,14.54,2535.22,49.78,3071.82,41.87,92.23-1.36,166.94-75.16,169.6-167.36,10.35-358.53,27.15-1220.69-35.04-1620.95-13.1-84.29-84.25-147.32-169.51-150.05-472.3-15.11-2562.25-63.09-3098.6-51.04C73.86,693.38,0,768.94,0,861.47Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.84,853.95v1466.26c0,74.13,59.5,134.52,133.62,135.63l2992.25,36.97c73.48,1.1,133.71-58.02,133.99-131.51l5.01-1453.16c.2-52.55-41.67-95.6-94.2-96.88L203.99,749.38c-58.75-1.43-107.15,45.81-107.15,104.58Z",
    style: {
      fill: "#91b3fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3379.23,2553.56h-.08l-3282.39-55.93c-2.65-.05-4.77-2.24-4.73-4.89,.04-2.65,2.21-4.75,4.89-4.73l3282.39,55.93c2.65,.05,4.77,2.24,4.73,4.89-.04,2.63-2.19,4.73-4.81,4.73Z",
    style: {
      fill: "#91b3fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2430.7,3310.56H1190.85c-33.68,0-58.98-23.98-52.46-49.74l15.91-62.92c4.78-18.92,25.6-32.81,50.33-33.58l1195.26-37.3c25.83-.81,48.7,12.91,54.33,32.57l28.68,100.22c7.45,26.04-17.96,50.75-52.19,50.75Z",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 208.67,
    y: 1111.84,
    width: 512.11,
    height: 358.89,
    rx: 12.64,
    ry: 12.64,
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.31,
    y: 1676.4,
    width: 512.11,
    height: 358.89,
    rx: 12.64,
    ry: 12.64,
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2617.61,
    y: 1679.52,
    width: 512.11,
    height: 358.89,
    rx: 12.64,
    ry: 12.64,
    style: {
      fill: "url(#linear-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1783.04,
    y: 1677.81,
    width: 512.11,
    height: 358.89,
    rx: 12.64,
    ry: 12.64,
    style: {
      fill: "url(#linear-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1777.33,
    y: 2230.18,
    width: 512.11,
    height: 358.89,
    rx: 12.64,
    ry: 12.64,
    style: {
      fill: "url(#linear-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.31,
    y: 2232.54,
    width: 512.11,
    height: 358.89,
    rx: 12.64,
    ry: 12.64,
    style: {
      fill: "url(#linear-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1024.55,
    y: 1115.91,
    width: 512.11,
    height: 358.89,
    rx: 12.64,
    ry: 12.64,
    style: {
      fill: "url(#linear-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1874.64,
    y: 1114.2,
    width: 512.11,
    height: 358.89,
    rx: 12.64,
    ry: 12.64,
    style: {
      fill: "url(#linear-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2703.16,
    y: 1118.27,
    width: 512.11,
    height: 358.89,
    rx: 12.64,
    ry: 12.64,
    style: {
      fill: "url(#linear-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1390.48,96.24h873.39c10.29,0,18.64,8.35,18.64,18.64V828.62c0,10.29-8.35,18.64-18.64,18.64h-873.39c-10.29,0-18.64-8.35-18.64-18.64V114.88c0-10.29,8.35-18.64,18.64-18.64Z",
    style: {
      fill: "url(#linear-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1587.53,460.16h493.9c5.29,0,8.07-6.28,4.5-10.19l-247.25-271.5c-2.42-2.66-6.6-2.65-9.01,0l-246.65,271.5c-3.56,3.91-.78,10.19,4.51,10.19Z",
    style: {
      fill: "url(#linear-gradient-15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1612.74,460.16v278.53c0,6.48,5.26,11.74,11.74,11.74h112.43c2.5,0,4.54-2.03,4.54-4.54v-170.19c0-1.81,1.47-3.28,3.28-3.28h86.67c1.7,0,3.08,1.38,3.08,3.08v171.09c0,2.11,1.71,3.83,3.83,3.83h204.45c7.1,0,12.85-5.75,12.85-12.85V460.16h-442.87Z",
    style: {
      fill: "url(#linear-gradient-16)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2983.43,1096.39c-2.33,0-4.21-1.88-4.21-4.21v-76.92c0-14.51-11.8-26.34-26.31-26.37l-2487.85-6.16h-.07c-8.13,0-15.78,3.16-21.54,8.91-5.78,5.76-8.96,13.43-8.96,21.59v78.96c0,2.33-1.88,4.21-4.21,4.21s-4.21-1.88-4.21-4.21v-78.96c0-10.41,4.06-20.2,11.43-27.55,7.35-7.33,17.11-11.37,27.49-11.37h.09l2487.85,6.16c19.14,.05,34.71,15.66,34.71,34.8v76.92c0,2.33-1.88,4.21-4.21,4.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.48,1100.6c-2.33,0-4.21-1.88-4.21-4.21v-113.75c0-2.33,1.88-4.21,4.21-4.21s4.21,1.88,4.21,4.21v113.75c0,2.33-1.88,4.21-4.21,4.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2132.38,1104.81c-2.33,0-4.21-1.88-4.21-4.21v-113.75c0-2.33,1.88-4.21,4.21-4.21s4.21,1.88,4.21,4.21v113.75c0,2.33-1.88,4.21-4.21,4.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1799.55,982.63c-2.33,0-4.21-1.88-4.21-4.21v-130.61c0-2.33,1.88-4.21,4.21-4.21s4.21,1.88,4.21,4.21v130.61c0,2.33-1.88,4.21-4.21,4.21Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2306.52,2438.97c-2.32,0-4.21-1.88-4.21-4.21s1.88-4.21,4.21-4.21h50.88c5.16,0,10.01-2.02,13.65-5.67,3.64-3.65,5.64-8.5,5.62-13.66l-2.11-801.95c-.07-8.66-7.18-15.72-15.87-15.72h-193.89c-19.16,0-34.76-15.59-34.76-34.76v-79c0-2.33,1.88-4.21,4.21-4.21s4.21,1.88,4.21,4.21v79c0,14.52,11.81,26.33,26.33,26.33h193.89c13.29,0,24.19,10.81,24.29,24.1l2.11,801.97c.02,7.41-2.85,14.39-8.08,19.64-5.24,5.25-12.2,8.14-19.62,8.14h-50.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2372.53,1854.75h-80.05c-2.33,0-4.21-1.88-4.21-4.21s1.88-4.21,4.21-4.21h80.05c2.33,0,4.21,1.88,4.21,4.21s-1.88,4.21-4.21,4.21Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M273.17,2438.97h-40.52c-10.23,0-19.84-4-27.06-11.24-7.22-7.25-11.18-16.87-11.15-27.1l2.27-791.4c.1-13.31,11-24.12,24.29-24.12h193.89c14.52,0,26.33-11.81,26.33-26.33v-79c0-2.33,1.88-4.21,4.21-4.21s4.21,1.88,4.21,4.21v79c0,19.16-15.59,34.76-34.76,34.76H221c-8.68,0-15.8,7.06-15.87,15.74l-2.27,791.38c-.02,7.98,3.07,15.48,8.7,21.12,5.63,5.64,13.12,8.76,21.09,8.76h40.52c2.33,0,4.21,1.9,4.21,4.22s-1.89,4.21-4.21,4.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.03,1854.75h-80.05c-2.33,0-4.21-1.88-4.21-4.21s1.88-4.21,4.21-4.21h80.05c2.33,0,4.21,1.88,4.21,4.21s-1.88,4.21-4.21,4.21Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3218.39,1863.22h-.01l-85.38-.04c-2.33,0-4.21-1.89-4.21-4.21s1.89-4.21,4.21-4.21h0l85.38,.04h0c1.31,0,2.53-.51,3.46-1.44,.92-.93,1.42-2.16,1.41-3.47l-1.85-232.18c-.07-8.68-7.18-15.74-15.87-15.74h-193.89c-19.16,0-34.76-15.59-34.76-34.76v-79c0-2.33,1.88-4.21,4.21-4.21s4.21,1.88,4.21,4.21v79c0,14.52,11.81,26.33,26.33,26.33h193.89c13.29,0,24.19,10.81,24.29,24.1l1.85,232.18c.03,3.57-1.34,6.93-3.86,9.47-2.51,2.53-5.86,3.93-9.43,3.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3227.8,2996.51h-80.05c-2.33,0-4.21-1.88-4.21-4.21s1.88-4.21,4.21-4.21h80.05c2.33,0,4.21,1.88,4.21,4.21s-1.88,4.21-4.21,4.21Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2955.7,2036.12s-149.32,191.18,21.04,385.63l64.05-5.97s-123.29-197.97-68.38-355.78l90.73,6.62,50.17-32.7-157.61,2.2Z",
    style: {
      fill: "url(#linear-gradient-17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3037.48,2972.13s120.98,263.68,184.46,372.9c0,0,12.61,68.72,0,90.33l-10.74,4.78,50.14-1.49s4.45-92.44,.98-97.6c-3.48-5.16-10.44-4.82-10.44-4.82,0,0-21.5-170.34-83.77-206.69l-60.34-207.84-70.28,50.45Z",
    style: {
      fill: "url(#linear-gradient-18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3189.78,3453.09c-.07,1.21,39.15,.66,60.46,.27,7.87-.14,14.58-5.67,16.25-13.36l16.09-84.55c1.53-8.03-3.57-15.84-11.55-17.66l-8.98-2.05s-12.81,17.58-8.78,34.13c4.03,16.55,7.62,59.42-2.57,64.42-10.19,5-39.52,5.87-39.52,5.87,0,0-20.74,2.06-21.41,12.95Z",
    style: {
      fill: "url(#linear-gradient-19)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2922.81,3454.62c-3.97,2.26-2.33,8.32,2.23,8.27,35.66-.36,115.57-1.49,122.67-4.44,9.17-3.81-3.34-36.75-16.51-47.9l-72.69,23.72-35.72,20.35Z",
    style: {
      fill: "url(#linear-gradient-20)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2900.25,2955.32s78.18,378.21,100.3,451.99l-52.32,32.83s26.22-4.46,45.66-5.87c19.44-1.41,37.33-23.72,37.33-23.72l-6.27-10s-19.61-376.15-14.83-418.87l-109.86-26.37Z",
    style: {
      fill: "url(#linear-gradient-21)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2706.17,2073.13s-10.78,196.74,168.34,297.28l-43.12,98.35s-162.17-98.09-156.17-365.62c.17-7.68-2.6-15.13-7.61-20.95l-34.47-39.99c-13.13-15.23-18.04-35.9-13.16-55.41l4.54-18.13c1.52-6.07,8.43-8.99,13.85-5.85l3.6,2.09c11.47,6.66,20.56,16.77,25.98,28.88l16.92,37.83c6.32,14.13,20.9,22.71,36.32,21.38l10.46-.9-25.48,21.04Z",
    style: {
      fill: "url(#linear-gradient-22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2868.28,2355.67c29.97,8.31,131.49,35.02,194.87,33.93l-38.91,219.6,3.1,35.82-126.88-.57s-35.72-82.95-63.9-124.3c-8.14-11.94-2.08-26.19,2.53-39.89l-6.34-4.22c-6.45-4.29-9.25-12.36-6.84-19.72l30.9-94.53c1.6-4.76,6.62-7.45,11.47-6.11Z",
    style: {
      fill: "url(#linear-gradient-23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2890.29,2625.7l2.5,21.7s-35.85,107.38,17.93,358.17c0,0,116.48,33,212.21-45.96,0,0-27.01-236.71-34.38-247.73-36.74-54.92-61.22-66.86-61.22-66.86l-1.1-23.71s-102.39,18.51-135.94,4.4Z",
    style: {
      fill: "url(#linear-gradient-24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2939.95,2373.37c-.45-.59,26.49-81.31,26.49-81.31l38.58,3.5,15.07,91.58s-60.46,12.2-80.14-13.77Z",
    style: {
      fill: "url(#linear-gradient-25)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2995.79,2164.75c-2.57,1.6-82.44,34.61-65.28,117.52,1.01,4.9,4.28,9.05,8.85,11.09,11.72,5.23,36.95,14.18,67.13,11.11,41.84-4.25,69.25-77.26,68.09-98.51s-53.3-57.09-78.79-41.22Z",
    style: {
      fill: "url(#linear-gradient-26)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3020.09,2132.51c-2.1,.28-46.15,15.62-24.31,47.54,21.85,31.92,30.04,50.71,19.71,64.73-9.41,12.77-30.27,5.49-28.45,32.06,.36,5.32-1.94,10.48-6.35,13.47-19.65,13.3-67.6,54.25-20.09,112.64,3.86,4.75,4.66,11.3,1.68,16.64-13.91,24.95-43.14,98.06,62.67,138.61,104.55,40.07,142.3-28.27,152.84-55.59,2.28-5.91,8.1-9.53,14.42-9.23,11.49,.54,27.77-1.37,27.02-16.72-.45-9.32-6.27-17.68-13.15-24.38-6.81-6.63-5.46-18.24,2.8-22.94,6.24-3.55,11.76-9.08,14.09-17.72,6.34-23.48-6.31-93.68-73.6-105.58-5.61-.99-11.49-6.25-12.31-11.9-.01-.08-.03-.17-.04-.25-.9-5.46,.94-11.03,5.4-14.3,10.74-7.88,24.52-23.75,13.33-49.2-9.93-22.57-28.96-30.18-43.1-32.61-8.3-1.42-13.76-9.28-12.01-17.52,4.77-22.45,.61-58.42-80.55-47.77Z",
    style: {
      fill: "url(#linear-gradient-27)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1419.86,3157.18s-261.45,288.25-479.81,166.42c-175.49-97.91,73.83-72.32,285.32-118.58,16.6-3.63,12.25-28.44-4.59-26.21-165.47,21.94-417.95,39.87-461.81-46.41-66.2-130.25-2-88.01,199.48-69.19,201.49,18.81,240.31-30.94,108.79-61.92-131.52-30.99-340.74,37.55-389.48-26.18-48.74-63.73-75.38-190.24-94.81-244.65s250.81-136.04,323.87-64.62c73.06,71.42,132.39,230.84,219.09,259.95,86.7,29.11-6.56-111.91-64.06-184.7s-80.3-126.88,34.58-109.52c114.88,17.36,175.61,157.57,187.72,262.23,12.11,104.66,52.57,163.2,50.74,111.42-1.83-51.78-20.62-210.57-57.34-258.31-36.72-47.74,225.4,10.52,142.3,410.27Z",
    style: {
      fill: "url(#linear-gradient-28)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1398.58,3159.93c-1.15,.44-2.5,.25-3.49-.63-224.41-196.33-600.8-339.03-604.58-340.45-1.78-.67-2.68-2.65-2.01-4.43,.67-1.77,2.65-2.67,4.43-2.01,3.79,1.42,381.32,144.54,606.69,341.71,1.43,1.25,1.57,3.42,.32,4.85-.38,.44-.85,.76-1.36,.95Z",
    style: {
      fill: "#fff",
      opacity: 0.53
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1512.47,3341.28s-477.48,15.75-556.62-280.82c-63.61-238.35,126.84,3.31,348.29,150.23,17.38,11.53,35.54-13.49,19.18-26.43-160.7-127.14-392.21-334.41-353.61-446.78,58.27-169.63,75.88-76.95,231.42,116.75,155.54,193.7,232.57,185.42,147.53,43.01-85.04-142.42-324.2-268.32-309.65-365.73,14.55-97.41,103.32-228.98,134.69-292.58,31.37-63.61,334.2,104.89,333.65,230.32-.55,125.43-90.41,313.92-42.01,415.22,48.41,101.3,93.06-101.39,108.1-214.27,15.05-112.88,43.26-179.19,126.1-63.08,82.84,116.11,11.11,289.43-70.81,389.52-81.92,100.09-98.96,185.77-54.88,139.92,44.08-45.85,168.02-198.07,178.74-271.22,10.72-73.16,183.29,207.7-240.12,475.95Z",
    style: {
      fill: "url(#linear-gradient-29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1491.86,3324.87c-1.37-.64-2.35-1.99-2.43-3.61-18.63-365.57-214.38-819.3-216.36-823.84-.93-2.14,.05-4.62,2.19-5.55,2.13-.92,4.62,.05,5.55,2.19,1.98,4.55,198.34,459.66,217.04,826.78,.12,2.32-1.67,4.3-4,4.42-.72,.04-1.4-.11-2-.39Z",
    style: {
      fill: "#fff",
      opacity: 0.53
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModulesHeaderImg);
export default __webpack_public_path__ + "static/media/modules-header-img.623d01ea13d264dcf91c8394a70ef139.svg";
export { ForwardRef as ReactComponent };